export default {
  beta: 'Beta',
  actions: {
    send: 'Send',
    verify: 'Verify',
    resend: 'Resend OTP',
    logout: 'Logout',
    pay: 'Pay',
    submit: 'Submit',
    back: 'Back',
    cancel: 'Cancel',
    retry: 'Retry',
    add_photo: 'Add Photo',
  },
  status: {
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    pending: 'Pending',
    collected: 'Collected',
    paid: 'Paid',
    unpaid: 'Unpaid',
    overdue: 'Overdue',
    open: 'Open',
    in_progress: 'In Progress',
    completed: 'Completed',
  },
  nav: {
    home: 'Home',
    invoices: 'Invoices',
    maintenance: 'Maintenance',
    parcels: 'Parcels',
    vehicles: 'Vehicles',
    rewards: 'Rewards',
    // EP-135 Tier 1a — bottom-nav tab for shared-owner / dual-role persons.
    meetings: 'Meetings',
  },
  // EP-135 Tier 1a — used in MeetingsPage header for the owned-unit count.
  meetings_owned_units_one: '1 owned unit',
  meetings_owned_units_other: '{{count}} owned units',
  errors: {
    required: 'This field is required',
    something_went_wrong: 'Something went wrong. Please try again.',
    liff_not_configured: 'This LIFF app is not configured for any account.',
    network_error: 'Network error. Please check your connection.',
    not_in_line_title: 'Please open in LINE app',
    not_in_line_subtitle: 'This app is designed to work within LINE. Please open this link from the LINE app.',
  },
}
